var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoReminder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99891 14.4615C7.66718 14.4615 7.38359 14.3435 7.14812 14.1075C6.91266 13.8715 6.79492 13.5878 6.79492 13.2563H9.20516C9.20516 13.5888 9.08704 13.8728 8.85082 14.1083C8.6146 14.3437 8.33063 14.4615 7.99891 14.4615Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5897V12.5897H9.58441V11.5897H5.2051V6.61533C5.2051 5.84353 5.47797 5.18477 6.0237 4.63904C6.56942 4.09331 7.22818 3.82044 7.99998 3.82044C8.77178 3.82044 9.43054 4.09331 9.97627 4.63904C10.522 5.18477 10.7949 5.84353 10.7949 6.61533V7.33328H11.7948V6.61533C11.7948 5.71875 11.5181 4.92602 10.9647 4.23713C10.4113 3.54824 9.70082 3.10764 8.8333 2.91534V2.49996C8.8333 2.26848 8.75211 2.07173 8.58972 1.90969C8.42733 1.74765 8.2305 1.66663 7.99923 1.66663C7.76797 1.66663 7.57139 1.74765 7.4095 1.90969C7.24761 2.07173 7.16667 2.26848 7.16667 2.49996V2.91534C6.29914 3.10764 5.58867 3.54824 5.03525 4.23713C4.48184 4.92602 4.20513 5.71875 4.20513 6.61533V11.5897H3Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7439 12.2051V15.1281L13.6413 11.0769H12.3221L13.2631 8.66663H10.667V12.2051H11.7439Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoReminder);
export default __webpack_public_path__ + "static/media/AutoReminder.2aff4ca22f54d74ac953c862f11f107a.svg";
export { ForwardRef as ReactComponent };